import { type FormEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useCurrentWorkspace } from "~/api/queries";
import { ABILITY } from "~/api/types";
import { Button } from "~/foundation/components/Button";
import { Input } from "~/foundation/components/Input";
import { Spinner } from "~/foundation/components/Spinner";
import { usePolicy } from "~/policies/usePolicy";

export function Details() {
  const { t } = useTranslation();
  const { data: workspace, isLoading } = useCurrentWorkspace();
  const can = usePolicy(workspace);
  const [name, setName] = useState("");

  useEffect(() => {
    if (workspace) {
      setName(workspace.name);
    }
  }, [workspace]);

  if (isLoading || !workspace) {
    return <Spinner label={t("Loading")} />;
  }

  const editable = can[ABILITY.workspaceUpdate] === true;

  const submit = (event: FormEvent) => {
    event.preventDefault();
    // SLATE-LATER (§15): PATCH /workspaces/current once the endpoint exists.
    toast.success(t("Workspace saved"));
  };

  return (
    <form onSubmit={submit} className="flex flex-col gap-5">
      <Input
        label={t("Workspace name")}
        value={name}
        fullWidth
        readOnly={!editable}
        onChange={(event) => setName(event.target.value)}
      />
      <Input
        label={t("URL")}
        value={workspace.subdomain ?? ""}
        fullWidth
        readOnly
        hint={t("Changing the URL breaks existing links.")}
      />
      {editable ? (
        <div>
          <Button type="submit" variant="primary" disabled={name.trim() === ""}>
            {t("Save")}
          </Button>
        </div>
      ) : null}
    </form>
  );
}
